import { render, staticRenderFns } from "./signUp.vue?vue&type=template&id=8532b95e&scoped=true"
import script from "./signUp.vue?vue&type=script&lang=js"
export * from "./signUp.vue?vue&type=script&lang=js"
import style0 from "./signUp.vue?vue&type=style&index=0&id=8532b95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8532b95e",
  null
  
)

export default component.exports